import Geolocation from 'ol/Geolocation';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Feature} from "ol";
import CircleStyle from "ol/style/Circle";
import {Point} from "ol/geom";
import {Fill, Stroke, Style} from "ol/style";
import {removeLayer} from "@/helpers/ol/ol-layer-helper";
import {getDefaultZoom} from "@/helpers/ol/ol-zoom-helper";

let geolocation
let vectorLayer
let intervalGeoLocation
let loaded = false
export function getGeoLocation() {
    return geolocation
}

export function setGeoLocation(map, removeAfter2Seconds = false, withZoom = false) {

    removeGeoLocation()

    loaded = false

    geolocation = new Geolocation({
        // enableHighAccuracy must be set to true to have the heading value.
        trackingOptions: {
            enableHighAccuracy: true,
        },
        projection: map.getView().getProjection(),
    });

    const accuracyFeature = new Feature();
    accuracyFeature.setStyle(
        new Style({
            fill: new Fill({
                color: 'rgba(136,151,170,0.2)'
            }),
            stroke: new Stroke({
                color: 'rgb(136,151,170)',
                width: 2,
            }),
        })
    );

    geolocation.on('change:accuracyGeometry', function () {
        accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());


        if(!loaded) {
            let animate = {
                center: geolocation.getPosition(),
                duration: 2000,
            }
            if(withZoom) {
                animate.zoom = getDefaultZoom()
            }
            map.getView().animate(animate);
            loaded = true

            if(removeAfter2Seconds) {
                setTimeout(() => {
                    removeGeoLocation()
                }, 4000)
            }
        }
    });

    const positionFeature = new Feature();
    positionFeature.setStyle(
        new Style({
            image: new CircleStyle({
                radius: 6,
                fill: new Fill({
                    color: '#858380',
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2,
                }),
            }),
        })
    );

    geolocation.on('change:position', function () {
        const coordinates = geolocation.getPosition();
        positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    });

    vectorLayer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: 'geoLocation',
        zIndex: 1000,
        source: new VectorSource({
            features: [accuracyFeature, positionFeature],
        }),
    });

    map.addLayer(vectorLayer)
    geolocation.setTracking(true)

    // // Testen op iOS
    // if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
    //
    //     console.log('checkkk')
    //     DeviceOrientationEvent.requestPermission()
    //         .then(permissionState => {
    //             if (permissionState === 'granted') {
    //                 window.addEventListener('deviceorientationabsolute', (event) => {
    //                     const alpha = event.alpha;
    //                     if (alpha !== null) {
    //                         const rotationRad = -alpha * (Math.PI / 180); // OL gebruikt radianen, negatief om de kaart correct te draaien
    //                         window.view.setRotation(rotationRad);
    //                         console.log("setRotation:", rotationRad);
    //                     }
    //                     console.log("Kompasrichting:", alpha);
    //                 }, true);
    //             } else {
    //                 console.log("Geen toegang tot oriëntatiegegevens");
    //             }
    //         })
    //         .catch(console.error);
    // } else {
    //     // Voor Android of browsers zonder toestemming nodig
    //     window.addEventListener('deviceorientationabsolute', (event) => {
    //         const alpha = event.alpha;
    //         if (alpha !== null) {
    //             const rotationRad = -alpha * (Math.PI / 180); // OL gebruikt radianen, negatief om de kaart correct te draaien
    //             window.view.setRotation(rotationRad);
    //             console.log("setRotation:", rotationRad);
    //         }
    //         console.log("Kompasrichting:", alpha);
    //     }, true);
    // }
}

export function removeGeoLocation() {
    if(geolocation) {
        removeLayer('geoLocation', false)
        geolocation.setTracking(false)
        loaded = false
    }
}

export function setGeoLocationInterval(interval) {
    clearInterval(intervalGeoLocation)
    if(interval) {
        intervalGeoLocation = setInterval(() => {
            window.map.getView().animate({
                center: geolocation.getPosition(),
                duration: 2000
            });
        }, interval)
    }
}
